export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14944.0f38d325.jpg";